import { Component, OnInit, inject } from '@angular/core';
import { JeevesProductGridViewComponent } from 'gung-standard-jeeves';
import {
  PriceService,
  GungFlowService,
  AuthService,
  LocationConfigService,
  CustomerService,
  Product,
  GungAnonymousConfigService
} from 'gung-standard';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';

@Component({
    selector: 'cult-product-card',
    templateUrl: './cult-product-card.component.html',
    styleUrls: ['./cult-product-card.component.scss'],
    standalone: false
})
export class CultProductCardComponent extends JeevesProductGridViewComponent implements OnInit {
  isReturnFlow = false;
  customerPriceList: string = '';

  constructor(
    protected priceService: PriceService,
    protected gungFlowService: GungFlowService,
    protected authService: AuthService,
    protected gungAnonymousConfigService: GungAnonymousConfigService,
    protected router: Router,
    protected locationConfigService: LocationConfigService,
    private customerService: CustomerService
  ) {
    super(priceService, gungFlowService, authService, gungAnonymousConfigService, router, locationConfigService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.gungFlowService
      .getSelectedFlow()
      .pipe()
      .subscribe(flow => {
        if (flow.isReturnOrder) {
          this.isReturnFlow = true;
        }
      });

    const customerIdFromLocalstorage = localStorage.getItem('selectedCustomerId');

    if (customerIdFromLocalstorage) {
      this.customerService
        .getCustomer(customerIdFromLocalstorage)
        .pipe()
        .subscribe(customer => (this.customerPriceList = customer.extra.kus.prislista || ''));
    }
  }
}
